import Number from './Number.view';
import { getFormattedNumber, getNumberVariant, FORMAT_MODE } from './utils';

export { Number, getFormattedNumber, getNumberVariant, FORMAT_MODE };

export default Number;
